import { render, staticRenderFns } from "./SaveImagenCartera.vue?vue&type=template&id=6c0ba1d8&scoped=true"
import script from "./SaveImagenCartera.vue?vue&type=script&lang=js"
export * from "./SaveImagenCartera.vue?vue&type=script&lang=js"
import style0 from "./SaveImagenCartera.vue?vue&type=style&index=0&id=6c0ba1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0ba1d8",
  null
  
)

export default component.exports